import { Link, Outlet, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import Footer from "./Footer";

export default function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const nav = [
    { to: "/", label: "Home" },
    { to: "/download", label: "Download" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <>
      <header style={{
        position: "sticky", top: 0, zIndex: 50,
        background: "rgba(248,247,242,0.92)",
        backdropFilter: "blur(10px)",
        borderBottom: "1px solid var(--stone)"
      }}>
        <div className="container" style={{
          display: "flex", alignItems: "center", justifyContent: "space-between", height: 64
        }}>
          <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none", color: "var(--charcoal)" }}>
            <div style={{
              width: 32, height: 32, borderRadius: 9,
              background: "var(--accent)", color: "white",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13
            }}>
              TG
            </div>
            <span style={{ fontFamily: "var(--font-display)", fontWeight: 600, fontSize: 18 }}>TokenGuard</span>
          </Link>

          <nav style={{ display: "flex", gap: 32, alignItems: "center" }} className="desktop-nav">
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                style={{
                  fontSize: 14, fontWeight: 500,
                  color: pathname === n.to ? "var(--accent-dark)" : "var(--slate)",
                  textDecoration: "none"
                }}
              >
                {n.label}
              </Link>
            ))}
            <Link to="/download" className="btn btn-primary" style={{ padding: "10px 20px", fontSize: 14 }}>
              Get the app
            </Link>
          </nav>

          <button
            className="mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            style={{ background: "none", border: "none", color: "var(--charcoal)", display: "none" }}
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {menuOpen && (
          <div className="mobile-nav" style={{
            display: "none",
            borderTop: "1px solid var(--stone)",
            padding: "16px 24px",
            background: "var(--warm-white)"
          }}>
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setMenuOpen(false)}
                style={{ display: "block", padding: "10px 0", fontSize: 15, color: "var(--charcoal)" }}
              >
                {n.label}
              </Link>
            ))}
            <Link to="/download" className="btn btn-primary" style={{ marginTop: 8, width: "100%" }}>
              Get the app
            </Link>
          </div>
        )}
      </header>

      <main>
        <Outlet />
      </main>

      <Footer />
    </>
  );
}
